/**
 * populate props required to preview SBN pages using MWP preview
 * @param {*} previewComponents - array of component payload objects to be previewed
 * @returns {object} object with SBN specific props
 */
export const populateSbnPreviewProps = previewComponents => {
  const sbnPreviewProps = {
    contentById: {},
    headerIds: [],
    inlineIds: [],
    seoFooterContentId: ''
  };
  previewComponents.forEach(payload => {
    sbnPreviewProps.contentById[payload.Id] = payload;
    switch (payload.Variation) {
      case 'SEO Content Block':
        sbnPreviewProps.seoFooterContentId = payload.Id;
        break;
      case 'Promo Tile':
        sbnPreviewProps.inlineIds.push(payload.Id);
        break;
      case 'Tile':
      default:
        sbnPreviewProps.headerIds.push(payload.Id);
    }
    return sbnPreviewProps;
  });
  return sbnPreviewProps;
};
